import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

const NavContext = createContext(null);

export function NavProvider({ children }) {
  const [navOpen, setNavOpen] = useState(false);
  const [projectsOpen, setProjectsOpen] = useState(false);

  const closeAllMenus = useCallback(() => {
    setProjectsOpen(false);
    setNavOpen(false);
  }, []);

  const openNav = useCallback(() => {
    setNavOpen(true);
  }, []);

  const toggleNav = useCallback(() => {
    setNavOpen((v) => !v);
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeAllMenus();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [closeAllMenus]);

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    if (navOpen) document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [navOpen]);

  return (
    <NavContext.Provider
      value={{
        navOpen,
        setNavOpen,
        projectsOpen,
        setProjectsOpen,
        closeAllMenus,
        openNav,
        toggleNav,
      }}
    >
      {children}
    </NavContext.Provider>
  );
}

export function useNav() {
  const ctx = useContext(NavContext);
  if (!ctx) {
    throw new Error("useNav must be used within NavProvider");
  }
  return ctx;
}
